import { EmptyArray } from 'lib/array/arrayUtils'
import { filterObject, getAttribute, mapObject, omitKeys } from 'lib/object/objectUtils'

export const initialFormState: App.Checkout.FormState = {
  editIdx: 0,
  activeHeadIdx: 0,
  travellerForms: [],
  commsResubscribe: undefined,
}

const schemaDeref = (fieldSchema: App.Checkout.FormFieldSchema, formSchema: App.Checkout.FormSchema) => {
  if ('$ref' in fieldSchema && fieldSchema.$ref) {
    const parts = fieldSchema.$ref.split('/')
    const path = parts.slice(1)
    return getAttribute(formSchema, path)
  } else {
    return fieldSchema
  }
}

export function flattenFormFields(properties: App.Checkout.TravellerFormSchema['properties'], formSchema: App.Checkout.FormSchema): App.Checkout.TravellerFormSchema['properties'] {
  let flattened = mapObject(properties, property => schemaDeref(property, formSchema))
  for (const key in properties) {
    const fieldSchema = flattened[key]
    if (fieldSchema.subFields) {
      flattened = {
        ...omitKeys([key], flattened),
        ...fieldSchema.subFields,
      }
    }
  }
  return flattened
}

export function flattenRequiredArray(schema: App.Checkout.TravellerFormSchema, formSchema: App.Checkout.FormSchema): Array<string> {
  let flattened = schema.required
  if (!flattened || flattened.length === 0) {
    return EmptyArray
  }
  for (const key in schema.properties) {
    const fieldSchema = schemaDeref(schema.properties[key], formSchema)
    if (flattened.includes(key) && 'subFieldsRequired' in fieldSchema && Array.isArray(fieldSchema.subFieldsRequired)) {
      flattened = [
        ...flattened.filter(k => k !== key),
        ...fieldSchema.subFieldsRequired,
      ]
    }
  }
  return flattened
}

export function removeUnknownTravellersAndFields(
  schema: App.Checkout.FormSchema,
  forms: App.Checkout.FormState['travellerForms'],
): App.Checkout.FormState['travellerForms'] {
  const schemaTravellers = new Set(Object.keys(schema.properties))
  if (schema) {
    return forms
      .filter(form => schemaTravellers.has(form.id))
      .map(form => {
        const fields = new Set(Object.keys(flattenFormFields(schema.properties[form.id].properties, schema)))
        return filterObject(form, (key: keyof App.Checkout.TravellerForm) => (
          key === 'id' ||
          // Temporary until old phone field is removed from schemas
          key === 'phone' ||
          // Not sure why this cast is needed in strict mode... keyof App.Checkout.TravellerForm should be `string`,
          // but Typescript thinks it's `string | number`??
          fields.has(key as string)
        )) as App.Checkout.TravellerForm
      })
  }
  return forms
}
